import React from "react"

import { BACKEND_APIS } from "@constants"
import { acriss } from "@signals"
import { AppAcrissAutocomplete } from "@components"


export default function AppCommonFiltersAcrissAutocomplete({ ...props }) {
	return <AppAcrissAutocomplete
		value={acriss.value}
		onChange={e => acriss.value = e.target.value}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/acriss`}
		{...props}
	/>
}